module.exports = __webpack_public_path__ + "img/link.42d22e5c.svg";